import React from 'react';

export default function PageLoader() {
  return (
    <div className="w-full h-full">
      <div className="pt-4 px-4 sm:pt-12 w-full mx-auto">
        <div className="animate-pulse flex-1 space-y-8">
          <div className="h-12 bg-primary rounded w-3/4" />
        </div>
        <div className="animate-pulse flex space-x-4 pt-12">
          <div className="flex-1 space-y-8 py-1">
            <div className="h-4 bg-primary rounded" />
            <div className="space-y-8">
              <div className="h-4 bg-primary rounded" />
              <div className="h-4 bg-primary rounded w-5/6" />
            </div>
          </div>
          <div className="flex-1 space-y-8 py-1">
            <div className="h-4 bg-primary rounded w-3/4" />
            <div className="space-y-8">
              <div className="h-4 bg-primary rounded" />
              <div className="h-4 bg-primary rounded w-5/6" />
            </div>
          </div>
        </div>
        <div className="animate-pulse flex space-x-4 pt-12 pb-12">
          <div className="flex-1 space-y-8 py-1">
            <div className="h-4 bg-primary rounded" />
            <div className="space-y-8">
              <div className="h-4 bg-primary rounded" />
              <div className="h-4 bg-primary rounded w-5/6" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
